// extracted by mini-css-extract-plugin
export default {"hide":"style_hide__3lvVr","spotlightWrapper":"style_spotlightWrapper__VAff+","container":"style_container__NLSiW"};